import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import navbar from './navbar'
import { scroll_functions, anchor_scroll_at_load } from './scroll-functions'

// loader
window.addEventListener('load', () => {
    document.body.classList.remove('loading')
})
if (window.innerWidth > 768) {
    window.addEventListener('beforeunload', () => {
        document.body.classList.add('loading')
    })
}

if (navigator.userAgent.indexOf('Edge') < 0) {
    anchor_scroll_at_load()
}

document.addEventListener('DOMContentLoaded', () => {
    navbar()
    scroll_functions()

    /* --------------------------------- loader --------------------------------- */
    if (window.innerWidth <= 768) {
        let links = document.querySelectorAll('a:not([href$=".png"]):not([href$=".jpg"]):not([href$=".jpeg"]):not([href$=".pdf"])')
        
        links.forEach(link => {
            let href = link.getAttribute('href'),
                fancybox = link.hasAttribute('data-fancybox')

            if (href !== null) {
                if (!href.includes('#') && !href.includes('?') && fancybox !== true) {
                    link.addEventListener('click', () => {
                        document.body.classList.add('loading')
                    })
                }
            }
        })
    }

    /* ---------------------------- searchform popup ---------------------------- */
    let container = document.querySelector('.searchform-container'),
        input = document.querySelector('.searchform-input'),
        toggle = document.querySelector('.searchform-toggle'),
        close = document.querySelector('.searchform-close')

    if (toggle !== null) {
        toggle.addEventListener('click', (e) => {
            e.preventDefault()
            container.style.transform = 'scale(1)'
            container.style.opacity = '1'
            input.focus()
            disableBodyScroll(container)
        })
        input.addEventListener('click', (e) => {
            e.stopPropagation()
        })
        container.addEventListener('click', () => {
            closeSearchformPopup()
        })
        close.addEventListener('click', () => {
            closeSearchformPopup()
        })
        container.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' || e.key === 'Esc') {
                closeSearchformPopup()
            }
        })
    }
    
    const closeSearchformPopup = () => {
        container.style.transform = 'scale(0)'
        container.style.opacity = '0'
        enableBodyScroll(container)
    }

})